module.exports = __webpack_public_path__ + "imgs/flower.5c7bdd54a9ac1f8f0dfc500791f96a5f.jpg";